module.exports = __webpack_public_path__ + "static/media/logo_wooribank.2698102a.svg";